import { getContext } from '@fiverr-private/fiverr_context';
import { LIONS_FINAL_PRICE_UPFRONT } from '../experimentsEnum';
import {
    LOCAL_SITE_COUNTRIES,
    MAIN_SITE_COUNTRIES,
    EXCLUDED_CURRENCIES
} from '../../../server/middlewares/allocateToExperiments/experiments/finalPriceUpfront/constants';
import { inExperiment } from '..';

/**
 * Determine if the user state matches the requirements
 * for experience the "final price upfront" test.
 * @returns {boolean} whether to display gig price including fees or not
 */
export const shouldDisplayFinalPriceUpfront = () => {
    const { abTests, currency, countryCode } = getContext();
    const isCountryInTest = LOCAL_SITE_COUNTRIES.includes(countryCode) || MAIN_SITE_COUNTRIES.includes(countryCode);
    const isCurrencyExcluded = EXCLUDED_CURRENCIES.includes(currency);

    return inExperiment(LIONS_FINAL_PRICE_UPFRONT, abTests) && isCountryInTest && !isCurrencyExcluded;
};
